import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'apply',
  pure: true,
})
export class ApplyFunctionPipe implements PipeTransform {
  transform<T, R>(value: T, methodToApply: (arg: T) => R): R {
    return methodToApply(value);
  }
}
